import React from 'react';
import UsersProfileContain from '../../Componant/Users/UsersProfile';

const UserProfile = () => {
  return (
    <div className='page-body'>
      <UsersProfileContain />
    </div>
  );
};

export default UserProfile;
